import React from 'react'
import CategoryPage from './CategoryPage'

const Accessories = () => {
  return <CategoryPage urlCategory="accessories"/>
}

export default Accessories
